/**
 * @copyright Copyright 2015-2016 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/keys",
    "mw-form/Spinner",
    "../mixins/property/MnemonicMixin",
    "../mixins/property/MnemonicKeyNavDirectionMixin",
    "../mixins/ColumnWidthMixin",
    "../mixins/property/TypeMixin",
    "mw-form/mixins/property/DescriptionMixin",
    "../mixins/property/DescriptionOverrideMixin",
    "../mixins/AcceptFocusMixin",
    "mw-form/mixins/property/ShortcutMixin",
    "mw-form/mixins/mixinDependencyValidator"

], function (declare, lang, keys, Spinner, MnemonicMixin, MnemonicKeyNavDirectionMixin, ColumnWidthMixin, TypeMixin,
    DescriptionMixin, DescriptionOverrideMixin, AcceptFocusMixin, ShortcutMixin, mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([Spinner, MnemonicMixin, MnemonicKeyNavDirectionMixin,
        ColumnWidthMixin, TypeMixin, DescriptionMixin, DescriptionOverrideMixin, AcceptFocusMixin, ShortcutMixin]), {
        visualFamily: "default",
        width: 70,
        mnemonicKeyNavDirection: "none",
        _scaleToParentWidth: true,

        postCreate: function () {
            this.inherited(arguments);
            this._textField.set("visualFamily", "toolstrip");
        },

        _setMinimumAttr: function(minimum) {
            this.set("limits", {
                minimum: minimum,
                maximum: this.limits.maximum
            });
            
            this._set("minimum", minimum);
        },

        _setMaximumAttr: function(maximum) {
            this.set("limits", {
                minimum: this.limits.minimum,
                maximum: maximum
            });
            this._set("maximum", maximum);
        },

        _setValueAttr: function (value) {
            if ((value < this.get("limits").minimum) ||
                (value > this.get("limits").maximum)) {
                return;
            }

            this._startValue = parseFloat(value);
            this._clickCount = 0;

            this._textField.set("value", value + "");
            this._set("value", value);
            this._setButtonState();
        },
        
        // g2158341 - Overridding getValue because now mw-form spinner return spinner value and not textField value
        _getValueAttr: function () {
            return this._isNumeric(this._textField.get("value")) ?
                parseFloat(this._textField.get("value")) : this._textField.get("value");
        },

        _onKeyDown: function (event) {
            this.inherited(arguments);
            if (event.keyCode === keys.ENTER) {
                // Need preventDefault to stop page down of the page
                if (this.get("value") + "" === this._textField.inputNode.value) {
                    this.emit("recommit", {
                        mwEventData: {
                            value: this.get("value")
                        }
                    });
                }
                this.emit("restorefocustolastnonrefuseelement");
                this.emit("commit", {});
            } else if (event.keyCode === keys.ESCAPE) {
                this.emit("restorefocustolastnonrefuseelement");
            }
        },

        resize: function() {
            // 22px is width of buttonContainer and 1px to cover the right border of textField
            this.containerNode.style.width = "calc(100% -  21px)"; // (22px - 1px)
            this._textField.domNode.style.width = "100%";
        }
    });

});
